(function () {
  const initSlider = (section) => {
    const box = section.querySelector(".feature-icon-and-content");
    const slider = section.querySelector(".swiper--feature-icon-and-content");

    if (!slider) return;

    const slides = slider.querySelectorAll(".feature-icon-and-content-card");

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    const spaceBetween = box.getAttribute("data-space-between")
      ? Number(box.getAttribute("data-space-between")) * 10
      : 24;

    const spaceBetweenMobile = slider.classList.contains(
      "swiper--feature-icon-and-content--visible-overflow"
    )
      ? 8
      : 16;

    const nextBtn = slider.querySelector(".feature-icon-and-content-button--next");
    const prevBtn = slider.querySelector(".feature-icon-and-content-button--prev");
    const scrollbar = slider.querySelector(".swiper-scrollbar");

    new Swiper(slider, {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: spaceBetweenMobile,
      speed: 800,
      mousewheel: {
        forceToAxis: true,
      },
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "feature-icon-and-content-button--disabled",
      },
      scrollbar: {
        el: scrollbar,
        grabCursor: true,
        draggable: true,
        hide: false,
      },
      breakpoints: {
        576: {
          spaceBetween: spaceBetween,
        },
      },
    });
  };

  const destroySlider = (section) => {
    const slider = section.querySelector(".swiper--feature-icon-and-content");
    const slides = section.querySelectorAll(".feature-icon-and-content-card");

    if (slider?.swiper) slider.swiper.destroy();

    slides.forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove("swiper-slide");
    });
  };

  const initFeatureIconAndContent = (section) => {
    if (!section || !section?.classList.contains("feature-icon-and-content-section")) return;

    const box = section.querySelector(".feature-icon-and-content");

    if (!box) return;

    const hasMobileSlider =
      box.getAttribute("data-enable-mobile-slider") === "true";
    const hasDesktopSlider =
      box.getAttribute("data-enable-desktop-slider") === "true";

    const sectionResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 576 && hasMobileSlider) {
          initSlider(section);
        } else if (entry.contentRect.width >= 576 && hasDesktopSlider) {
          initSlider(section);
        } else {
          destroySlider(section);
        }
      });
    });

    sectionResizeObserver.observe(section);
  };

  initFeatureIconAndContent(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initFeatureIconAndContent(event.target);
  });
})();

